





































































































import { Component, Vue, Watch, Model } from 'vue-property-decorator'
import $ajax from 'axios'
import { getStoreUuid, isIos } from '@/utils/tool'
import AgreeTick from '@/components/Icon/AgreeTick.vue'
import Dialog from './Dialog.vue'
import DialogIframe from './DialogIframe.vue'
import { validatePhone, validateSMSCode, validatePwd, validateEmail } from '@/utils/validate'
import tips from '@/utils/wrongTips'
import { _post, _picPost } from '@/utils/apiMethods'
import { config } from '@/utils/ajaxConfig'
import analytics from '@/firebase/firebase'

@Component({
    components: {
        AgreeTick,
        Dialog,
        DialogIframe,
    },
    directives: {
        ansInput: {
            bind(el, binding) {
                el.addEventListener('focus', () => {
                    const name = binding.value;
                    analytics(`lazadaH5_inputClick_${name}`);
                })
                el.addEventListener('blur', (ev:FocusEvent) => {
                    const name = binding.value;
                    const { value } = ev.target as HTMLInputElement;
                    if (value.trim().length > 0) {
                        analytics(`lazadaH5_input_${name}`)
                    } else {
                        analytics(`lazadaH5_noInput_${name}`)
                    }
                });
            }
        }
    }
})
export default class RegisterBox extends Vue {
    phoneNum: string = sessionStorage.getItem('phoneNum') || ''
    smsCode: string = ''
    sendSMSContent: string = 'Get SMS Code'
    // totalTime: number = Number(sessionStorage.getItem('totalTime')) || 60
    // sendSMSLock: boolean = Boolean(sessionStorage.getItem('sendSMSLock')) || false
    totalTime: number = 60 // 倒计时时间
    sendSMSLock: boolean = false // 按钮锁
    resendDownLoadBtnLock: boolean = false // 按钮锁
    password: string = ''
    passwordAgain: string = ''
    email: string = ''
    agree: boolean = false
    showPhoneTips: boolean = false
    showEmailTips: boolean = false
    registerSuccess: boolean = Boolean(sessionStorage.getItem('registerSuccess')) || false
    dialogShow: boolean = false
    dialogIframeShow: boolean = false
    timeId: any = ''
    imgUrl: string = ''
    picCode: string = ''
    picId: string = ''

    btnCountDown(): void {
        this.sendSMSContent = `${this.totalTime}s`
        this.sendSMSLock = true
        sessionStorage.setItem('sendSMSLock', 'true')
        this.timeId = setInterval(() => {
            this.totalTime = this.totalTime - 1
            this.sendSMSContent = `${this.totalTime}s`
            sessionStorage.setItem('totalTime', this.totalTime.toString())
            if (this.totalTime <= 0) {
                this.resetSendBtn()
            }
        }, 1000)
    }
    resetSendBtn(): void {
        clearInterval(this.timeId)
        this.sendSMSLock = false
        this.totalTime = 60
        this.sendSMSContent = 'Get SMS Code'
        sessionStorage.removeItem('totalTime')
    }
    resendSmsByDownLoad(): void {
        if (this.resendDownLoadBtnLock) {
            return
        }
        analytics('lazadaH5_resendDownloadMsgBtnClick')
        this.resendDownLoadBtnLock = true
        this.$loading.show()
        _post('/varanus/version/sendsmsfordownload', {
            mobile: this.phoneNumFomat(this.phoneNum),
        }).then(res => {
            const { status, message } = res
            this.resendDownLoadBtnLock = false
            if (status === 0) {
                this.$toast('Has been sent')
                analytics('lazadaH5_resendDownloadMsgSuccess')
            } else {
                this.$toast(message)
                analytics('lazadaH5_resendDownloadMsgError')
            }
            this.$loading.hide()
        })
    }
    sendSMS(): void {
        // console.log('start')
        if (this.sendSMSLock) {
            return
        } else if (!validatePhone(this.phoneNum)) {
            analytics('lazadaH5_sendSMS_phoneError')
            this.$toast(tips.wrongPhone)
            return
        }
        analytics('lazadaH5_smsBtnClick')
        const uuid = getStoreUuid()
        const { picCode, picId } = this
        this.picCode = ''
        this.picId = ''
        this.$loading.show()
        _post('varanus/sendInviteVerifycode', {
            mobile: this.phoneNumFomat(this.phoneNum),
            imei: uuid,
            smsType: 63,
            verifyMode: 0,
            pictureVerifyCode: picCode,
            pictureId: picId
        }).then(res => {
            // console.log(res)
            const { status, message } = res
            this.$loading.hide()
            if (status === 0) {
                this.$toast('Has been sent')
                this.btnCountDown()
                analytics('lazadaH5_smsSendSuccess')
            } else if (status === 100003) {
                this.$toast('') // 不弹toast
                this.getPictureId()
                this.resetSendBtn()
            } else {
                this.resetSendBtn()
                analytics('lazadaH5_smsSendError')
            }
        })
    }
    getPictureId(): void {
        this.$loading.show()
        _post('/varanus/userinfo/generatepicture', {}).then(res => {
            const { status, message, content } = res
            this.$loading.hide()
            if (status === 0) {
                const imgUrl = `${config.picUrl}moon/captcha/v1/get?captchaId=${content.captcheId}`
                this.picId = content.captcheId
                this.imgUrl = imgUrl
            } else {
                this.$toast(message)
            }
        })
    }
    getPicCodeAndSend(code: string): void {
        this.picCode = code
        this.imgUrl = ''
        this.sendSMS()
    }
    agreementStatusChange() {
        this.agree = !this.agree
    }
    showTips({ name, show }: { name: string; show: boolean }) {
        // console.log(name, show)
        if (name === 'phone') {
            this.showPhoneTips = show
        } else {
            this.showEmailTips = show
        }
    }
    submit(): void {
        // console.log(validatePwd('12345678a'))
        const { phoneNum, smsCode, password, passwordAgain, email, agree, phoneNumFomat } = this
        if (!agree) {
            analytics('lazadaH5_submit_noCheckAgree');
            this.$toast(tips.notCheckAgreement)
            return
        } else if (!validatePhone(phoneNum)) {
            analytics('lazadaH5_submit_phoneError');
            this.$toast(tips.wrongPhone)
            return
        } else if (!validatePwd(password)) {
            analytics('lazadaH5_submit_pwdError')
            this.$toast(tips.wrongPwd)
            return
        } else if (!validateSMSCode(smsCode)) {
            analytics('lazadaH5_submit_smsError')
            this.$toast(tips.wrongSMSCode)
            return
        } else if (!validateEmail(email)) {
            analytics('lazadaH5_submit_emailError')
            this.$toast(tips.wrongEmail)
            return
        } else if (password !== passwordAgain) {
            analytics('lazadaH5_submit_repwdError')
            this.$toast(tips.pwdNotSame)
            return
        } else if (!(phoneNum && smsCode && password && passwordAgain && email)) {
            analytics('lazadaH5_submit_hasEmptyInput')
            this.$toast(tips.notEmpty)
            return
        }
        this.$loading.show()
        analytics('lazadaH5_submitBtnClick')
        _post('userbase/outerregister/land', {
            mobile: phoneNumFomat(phoneNum), // 默认加0
            verifyCode: smsCode,
            grantType: 1,
            outerRegisterType: 0,
            password,
            email,
        }).then(res => {
            const { status, message } = res
            if (status === 0) {
                this.registerSuccess = true
                sessionStorage.setItem('registerSuccess', 'true')
                sessionStorage.setItem('phoneNum', this.phoneNum)
                analytics('lazadaH5_submitSuccess')
            } else {
                this.$toast(message || 'error')
            }
            this.$loading.hide()
        })
    }
    dialogIframeOpen() {
        this.$loading.show()
        this.dialogIframeShow = true
        analytics('lazadaH5_iframeBtnClick')
    }
    dialogIframeClose() {
        this.dialogIframeShow = false
    }
    dialogClose() {
        this.imgUrl = ''
    }
    phoneNumFomat(phone: string, autoPrefix = true) {
        const phoneReg = /^0[1-9]\d{8,9}$/
        let mobile = String(phone).toString().trim();
        if (autoPrefix && mobile[0] !== '0') {
            mobile = `0${phone}`
        }
        return mobile
    }
    limitLength(type: string, $event: any) {
        // 不能直接用this[type]去改变值，ts会报错
        const { maxLength, value } = $event.target
        Object.assign(this, { [type]: value.slice(0, maxLength) })
    }
}
